import { getCookies } from 'cookies-next';
import { GetServerSidePropsContext, NextPageContext } from 'next';

export const getLastVisitedProductsCatNumbersCookie = (ctx?: GetServerSidePropsContext | NextPageContext) => {
    const cookies = getCookies({ req: ctx?.req, res: ctx?.res });
    const lastVisitedProductsCatNumbers: string | undefined = cookies.lastVisitedProducts ?? undefined;

    return lastVisitedProductsCatNumbers ? (JSON.parse(lastVisitedProductsCatNumbers) as string[]) : [];
};
